import { render, staticRenderFns } from "./UserDetailsDrawer.vue?vue&type=template&id=1d5576b1"
import script from "./UserDetailsDrawer.vue?vue&type=script&lang=js"
export * from "./UserDetailsDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports